module.exports = __webpack_public_path__ + "static/media/cracking-the-code-mobile.563143f2.jpg";